if (!customElements.get('business-calendar')) {
  customElements.define(
    'business-calendar',
    class extends HTMLElement {
      connectedCallback() {
        const cfgEl = this.querySelector('[data-calendar-config]');
        const wrap = this.querySelector('[data-calendar-months]');
        if (!cfgEl || !wrap) return;

        let cfg;
        try {
          cfg = JSON.parse(cfgEl.textContent);
        } catch (e) {
          return;
        }
        wrap.innerHTML = '';

        // An exception can cover a range: `date` is the first day and `endDate` the last.
        // Entries without `endDate` stay single-day, so existing data keeps working.
        // The guard keeps a mistyped end date (e.g. a year out) from spinning here.
        const MAX_EXCEPTION_DAYS = 400;
        const exMap = new Map();
        (cfg.exceptions || []).forEach((e) => {
          if (!e || !e.date) return;
          const start = parseKey(e.date);
          if (!start) return;
          const end = (e.endDate && e.endDate > e.date && parseKey(e.endDate)) || start;

          for (let i = 0; i < MAX_EXCEPTION_DAYS; i++) {
            const day = new Date(start.getFullYear(), start.getMonth(), start.getDate() + i);
            if (day > end) break;
            exMap.set(ymd(day), e);
          }
        });

        const todayKey = cfg.todayHint || ymd(new Date());
        const [ty, tm] = todayKey.split('-').map(Number);
        const weekdays = [
          'sunday',
          'monday',
          'tuesday',
          'wednesday',
          'thursday',
          'friday',
          'saturday',
        ];

        for (let m = 0; m < (cfg.monthsToShow || 2); m++) {
          const firstDay = new Date(ty, tm - 1 + m, 1);
          wrap.appendChild(renderMonth(firstDay, exMap, cfg, weekdays, todayKey));
        }

        function ymd(d) {
          const y = d.getFullYear();
          const mo = String(d.getMonth() + 1).padStart(2, '0');
          const da = String(d.getDate()).padStart(2, '0');
          return `${y}-${mo}-${da}`;
        }

        // `new Date('2026-08-13')` parses as UTC and can land on the previous day in
        // JST, so build the date from its parts instead.
        function parseKey(key) {
          const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(key));
          if (!m) return null;
          const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
          return Number.isNaN(d.getTime()) ? null : d;
        }

        function renderMonth(firstDay, exMap, cfg, weekdays, todayKey) {
          const month = document.createElement('section');
          month.className = 'business-calendar__month';

          const title = document.createElement('h3');
          title.className = 'business-calendar__month-title';
          title.textContent = `${firstDay.getFullYear()}年${firstDay.getMonth() + 1}月`;
          month.appendChild(title);

          const grid = document.createElement('div');
          grid.className = 'business-calendar__grid';

          (cfg.weekdayLabels || ['日', '月', '火', '水', '木', '金', '土']).forEach((wl, i) => {
            const cell = document.createElement('div');
            cell.className = `business-calendar__weekday business-calendar__weekday--${i}`;
            cell.textContent = wl;
            grid.appendChild(cell);
          });

          const startWeekday = firstDay.getDay();
          for (let i = 0; i < startWeekday; i++) {
            const blank = document.createElement('div');
            blank.className = 'business-calendar__day business-calendar__day--blank';
            grid.appendChild(blank);
          }

          const lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 1, 0).getDate();
          for (let day = 1; day <= lastDay; day++) {
            const date = new Date(firstDay.getFullYear(), firstDay.getMonth(), day);
            const y = date.getFullYear();
            const mo = String(date.getMonth() + 1).padStart(2, '0');
            const da = String(date.getDate()).padStart(2, '0');
            const key = `${y}-${mo}-${da}`;
            const weekdayName = weekdays[date.getDay()];
            const ex = exMap.get(key);

            const show = cfg.show || {};
            let kind = 'open';
            let note = '';
            if (ex) {
              kind = ex.type;
              note = ex.note || (cfg.labels && cfg.labels[ex.type]) || '';
            } else if ((cfg.weeklyClosed || []).includes(weekdayName)) {
              kind = 'weekly_closed';
            }
            // Hide categories the merchant has not enabled — render them as 通常営業日.
            if (kind !== 'open' && show[kind] === false) {
              kind = 'open';
              note = '';
            }

            const cell = document.createElement('div');
            cell.className = `business-calendar__day business-calendar__day--${kind}`;
            if (key === todayKey) cell.classList.add('business-calendar__day--today');
            cell.dataset.date = key;
            cell.dataset.kind = kind;

            const num = document.createElement('span');
            num.className = 'business-calendar__day-num';
            num.textContent = day;
            cell.appendChild(num);

            if (note) {
              cell.title = note;
              const noteEl = document.createElement('span');
              noteEl.className = 'business-calendar__day-note';
              noteEl.textContent = note;
              cell.appendChild(noteEl);
            }

            grid.appendChild(cell);
          }

          month.appendChild(grid);
          return month;
        }
      }
    }
  );
}
